import { createApiClient } from './createApiClient';

const { VITE_MANAGEMENT_API_BASE_URL } = import.meta.env;

const managementApi = createApiClient({
  baseURL: VITE_MANAGEMENT_API_BASE_URL as string,
});

export default managementApi;
